import { Card, Col } from "reactstrap";
import { Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { InfoSection } from "./InfoSection";
import UserSocialMediaAndFollow from "./UserSocialMediaAndFollow";

const UserData = () => {
  return (
    <Col sm="12">
      <Card className="hovercard text-center user-profile-card">
        <div className="cardheader"></div>
        <div className="user-image">
          <div className="avatar">
            <Image src={dynamicImage(`user/7.jpg`)} alt="user" />
          </div>
          <div className="icon-wrapper">
            <i className="icofont icofont-pencil-alt-5"></i>
          </div>
        </div>
        <div className="info">
          <InfoSection />
          <hr />
          <UserSocialMediaAndFollow />
        </div>
      </Card>
    </Col>
  );
};

export default UserData;
